import { FormieInterface } from '~/types/Formie'

/**
 * The Formie JS instance.
 */
export let Formie: FormieInterface | null = null;
// This queue holds methods that are called before Formie is loaded.
const queue: string[] = []

/**
 * Handle the Formie load event and initialize Formie forms.
 * @see src/templates/_layouts/skeleton.twig
 * @see src/assets/js/main.ts
 *
 * @param formie - The Formie instance.
 */
export function handleFormieLoad(formie): void {
  Formie = formie
  runQueue()
  initFormieForms()
}

/**
 * Initialize Formie forms on the page as soon as Formie is loaded.
 */
export function initFormieForms(): void {
  if (!Formie) {
    queue.push('initForms')
    return
  }
  Formie.initForms()
}

/**
 * Refresh all Formie forms as soon as Formie is loaded. to ensure they work on cached pages
 */
export function refreshFormieForms(): void {
  if (!Formie) {
    queue.push('refreshFormieForms')
    return;
  }

  Formie.forms?.forEach((form) => {
    if (form.config?.formHashId) {
      Formie.refreshForCache(form.config.formHashId)
    }
  });
}

/**
 * Run all queued methods that were called before Formie was loaded.
 */
function runQueue() {
  console.log('[Formie] Running queued methods:', queue)
  queue.forEach((method) => {
    try {
      if (Formie && typeof Formie[method as keyof FormieInterface] === 'function') {
        (Formie[method as keyof FormieInterface] as Function)()
      }
    } catch (err) {
      console.error(`[Formie] ${err}`)
    }
  });
}
